import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f8ac636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider-root" }
const _hoisted_2 = { class: "slider-container" }
const _hoisted_3 = ["min", "max", "step", "value", "id", "aria-valuemin", "aria-valuemax", "aria-valuenow", "aria-valuetext", "aria-labelledby"]
const _hoisted_4 = { class: "slider-ticks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "range",
        class: "slider",
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.step,
        value: _ctx.value,
        id: _ctx.id,
        ref: "slider-input",
        style: _normalizeStyle(_ctx.sliderBackground),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayValue($event))),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayValue($event))),
        "aria-valuemin": _ctx.min,
        "aria-valuemax": _ctx.max,
        "aria-valuenow": _ctx.value,
        "aria-valuetext": _ctx.screenReaderText,
        "aria-labelledby": _ctx.sliderLabel
      }, null, 44, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (value) => {
          return (_openBlock(), _createElementBlock("span", {
            key: value.key,
            class: "tick"
          }))
        }), 128))
      ])
    ])
  ]))
}